export const KEY_LANG = "lang";
export const KEY_SMART_VIEW = "smart_view";
export const KEY_DASHBOARD = "dashboard";
export const QUOTA_LIMIT_BANNER_DISABLED = "quota_limit_banner_disabled";
export const KEY_USER_EMAIL = "email";
export const KEY_USER_DISPLAY_NAME = "displayName";
export const KEY_USER_ID = "userId";
export const KEY_USER_COMPANY = "companyId";
export const HOME_TAB = "homeTab";
export const KEY_SMART_VIEW_FILTER = "smart_view_filter";
export const HIDE_DOC_STATUS_INFO_BANNER = "hide_doc_status_info_banner";
export const LOGGED_REAL_COMPANY = "logged_real_company";
export const MY_REVIEW_RIGHT_PANEL_WIDTH = "my_review_right_panel_width";
export const MY_REVIEW_LEFT_PANEL_WIDTH = "my_review_left_panel_width";
export const MY_REVIEW_OPEN_TOC = "my_review_open_toc";
export const KEY_SELECTED_SORTING_ALGORITHM = "key_selected_sorting_algorithm";
export const PORTFOLIO_ESPACE = "portfolio_espace";
export const PRODUCT_TOURS = "tours";
export const PRODUCT_TOUR_EXPLORATION = "solo_exploration";
export const KEY_NOTES_SELECTED_DOCUMENT = "notes_selected_document";
export const KEY_NOTES_PANEL_WIDTH = "notes_panel_width";
export const KEY_DOC_CENTER_TABLE_COLUMN_ORDER = "doc_center_table_column_order";
export const KEY_DOC_CENTER_TABLE_COLUMN_WIDTH = "doc_center_table_column_width";
export const KEY_PORTFOLIO_TABLE_COLUMN_ORDER = "portfolio_table_column_order";
